
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'feedback-public-submission-ui',
  currentProjectVersion: 'static-1.30591',
  depVersions: {
  "feedback-public-submission-ui": "static-1.30591",
  "emoji-mart": "static-3.4",
  "feedback-schema": "static-1.55043",
  "head-dlb": "static-1.5007",
  "hs-test-utils": "static-1.8184",
  "hubspot-dlb": "static-2.1854",
  "HubStyleTokens": "static-2.11634",
  "I18n": "static-7.1643",
  "quartz": "static-1.7241",
  "quartz-config": "static-1.1019",
  "quartz-core": "static-1.6460",
  "react-dlb": "static-1.82",
  "react-dnd": "static-4.51",
  "react-dnd-html5-backend": "static-2.10",
  "redux-mock-store": "static-1.8",
  "redux-thunk": "static-2.43",
  "reselect": "static-3.7",
  "sinon": "static-1.9",
  "tinymce": "static-6.5",
  "cssUtils": "static-1.838",
  "enviro": "static-4.455",
  "feedback-shared-ui": "static-1.55030",
  "feedback-utils": "static-1.55034",
  "forms-embed-utils-lib": "static-1.4626",
  "forms-utils-lib": "static-1.12893",
  "foundations-assets": "static-1.5036",
  "foundations-components": "static-1.8255",
  "foundations-theming": "static-1.4599",
  "hub-http": "static-1.6383",
  "hubspot-url-utils": "static-1.4132",
  "HubStyle": "static-2.11941",
  "icons": "static-2.660",
  "immutable": "static-2.79",
  "quick-fetch": "static-1.4034",
  "raven": "static-3.5925",
  "react": "static-7.188",
  "react-dom": "static-7.85",
  "react-input-autosize": "static-2.17",
  "react-redux": "static-7.71",
  "react-rhumb": "static-1.16862",
  "react-select-plus": "static-1.107",
  "react-utils": "static-2.5458",
  "react-virtualized": "static-2.101",
  "redux": "static-4.16",
  "StyleGuideUI": "static-3.490",
  "tinymce-plugins": "static-1.57934",
  "transmute": "static-2.85",
  "ui-images": "static-2.1198",
  "UIComponents": "static-3.8580",
  "hs-promise-rejection-tracking": "static-1.5587",
  "PortalIdParser": "static-2.404",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "metrics-js": "static-1.9637",
  "styled-components": "static-2.89",
  "bend-plugin-trellis-migration": "static-1.3518",
  "moment": "static-3.26",
  "bend-plugin-quartz": "static-1.3518",
  "quartz-webpack": "static-1.3465",
  "foundations-theming-specialty": "static-1.2315",
  "property-description-translator": "static-1.4002",
  "HeadJS": "static-2.775",
  "framer-motion": "static-1.74",
  "hs-test-utils-bend-plugin": "static-1.3295",
  "msw": "static-1.39",
  "testing-library": "static-1.154",
  "webpack-env": "static-1.54",
  "i18n-data": "static-1.224",
  "moment-timezone": "static-5.85",
  "jasmine": "static-4.4487",
  "jasmine-runner": "static-1.6619",
  "dispatcher": "static-1.140",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.850",
  "hubspotter-http": "static-1.4768",
  "mobile-manifest-mixins": "static-1.549",
  "module-federation": "static-1.28",
  "quartz-auth": "static-1.916",
  "quartz-head": "static-1.906",
  "quartz-i18n": "static-1.916",
  "quartz-routing": "static-1.671",
  "quartz-test": "static-1.916",
  "quartz-tracking": "static-1.620",
  "trellis-components": "static-1.2280",
  "ui-fonts": "static-1.896",
  "usage-tracker-container": "static-1.7504",
  "usage-tracker-core": "static-1.7364",
  "hs-lodash": "static-4.45",
  "sassPrefix": "static-1.159",
  "conversations-skeleton-state": "static-1.7410",
  "reference-resolvers": "static-1.8338",
  "sanitize-text": "static-1.8309",
  "PatternValidationJS": "static-1.437",
  "ReduxMessenger": "static-2.10525",
  "sanitize": "static-1.4639",
  "outpost": "static-1.4331",
  "rpc-client-utils": "static-1.4822",
  "underscore": "static-1.8",
  "bend-plugin-foundations-components": "static-1.4524",
  "floating-ui": "static-1.59",
  "hs-story-utils": "static-1.9586",
  "react-aria": "static-1.68",
  "react-create-root-preference": "static-1.41",
  "tanstack-table": "static-1.57",
  "trellis-assets": "static-1.2261",
  "bend-plugin-foundations-theming": "static-1.3082",
  "foundations-theming-base": "static-1.3584",
  "stylex": "static-1.36",
  "hs-locale-management": "static-1.199",
  "csstype": "static-1.50",
  "web-vitals": "static-1.8",
  "ai-components-ui-library": "static-1.9376",
  "atom": "static-1.5237",
  "codemirror": "static-5.97",
  "content-assistance-lib": "static-1.8010",
  "ContentUtils": "static-1.68859",
  "data-token-picker": "static-1.16701",
  "file-manager-components": "static-1.24110",
  "FileManagerCore": "static-1.39609",
  "FileManagerLib": "static-1.39750",
  "frontend-preferences-client": "static-1.8090",
  "hub-http-contrib": "static-1.3206",
  "interframe": "static-3.4920",
  "layout-dnd-components": "static-1.12766",
  "layout-dnd-utils": "static-1.11741",
  "property-translator": "static-1.5558",
  "react-codemirror": "static-1.10790",
  "react-colorpicker": "static-2.10371",
  "reference-resolvers-lite": "static-1.8259",
  "rich-text-lib": "static-1.20121",
  "tinymce-data": "static-1.40905",
  "tinymce-themes": "static-1.56790",
  "ui-addon-emoji-picker": "static-1.10046",
  "ui-addon-sales-email": "static-1.5374",
  "ui-brand-identity-lib": "static-1.15892",
  "bender-build-tools": "static-1.3301",
  "hub-http-shared-msw-handlers": "static-1.10376",
  "hubspotter-http-shared-msw-handlers": "static-1.10374",
  "usage-tracker-session-replay": "static-1.5200",
  "base-ui": "static-1.16",
  "react-day-picker": "static-1.5",
  "trellis-theming": "static-1.1110",
  "tanstack-virtual": "static-1.32",
  "autolinker": "static-3.11",
  "bend-plugin-chirp-manifest": "static-1.232",
  "chirp-fetch": "static-1.2051",
  "chatspot-core": "static-1.22135",
  "copilot-toolkit": "static-1.11565",
  "customer-data-objects-ui-components": "static-1.13192",
  "data-fetching-client": "static-1.9822",
  "diff-match-patch": "static-1.7",
  "superstore": "static-1.4922",
  "ui-addon-video-player": "static-1.8867",
  "ui-coaching-tips": "static-1.29031",
  "usage-tracker": "static-1.7514",
  "cms-field-types": "static-1.4976",
  "content-icons-ui": "static-1.2274",
  "integrations-lib": "static-1.16695",
  "customer-data-objects": "static-1.7841",
  "apollo-dlb": "static-3.86",
  "breeze-engine-lib": "static-1.1309",
  "apollo-link-hub-http": "static-2.4814",
  "apollo-stack-hubspot": "static-3.88",
  "graphql": "static-1.84",
  "immer": "static-1.33",
  "immerable": "static-1.4313",
  "ui-addon-iframeable": "static-1.9240",
  "video-components-external": "static-1.11831",
  "video-data-lib": "static-1.35489",
  "audio-components": "static-1.6167",
  "cropperjs": "static-1.10",
  "feedback-loader": "static-1.29606",
  "FileManagerImages": "static-1.37261",
  "foundations-components-legacy": "static-1.1280",
  "html-to-image": "static-1.56",
  "react-immutable-proptypes": "static-2.8",
  "redux-toolkit": "static-1.7",
  "salesImages": "static-1.528",
  "ui-universal-auth": "static-1.9171",
  "urlinator": "static-1.4696",
  "video-components": "static-1.13833",
  "video-embed": "static-1.36323",
  "ts-schema": "static-1.4199",
  "ContentData": "static-1.68934",
  "layout-data-lib": "static-1.10066",
  "react-dnd-compat": "static-1.4776",
  "browser-eslint": "static-2.57",
  "batch-promise": "static-1.1706",
  "external-options-client-types": "static-1.4244",
  "fast-json-stable-stringify": "static-1.4",
  "framework-data-schema-resolvers": "static-1.7058",
  "hs-promise-utils": "static-1.5757",
  "inbound-db-properties-service-client": "static-1.3964",
  "NamespacedHubStyle": "static-2.9171",
  "growth-onboarding-confetti": "static-1.3229",
  "SharedI18nStrings": "static-1.182",
  "ui-addon-i18n": "static-1.11311",
  "amplitude-session-replay-browser": "static-1.60",
  "markdown-it": "static-1.6",
  "magpie-lib": "static-1.5659",
  "magpie-types": "static-1.5119",
  "simple-logging-lib": "static-1.3211",
  "avatar-components": "static-1.2662",
  "customer-data-ui-utilities": "static-1.9985",
  "growth-onboarding-feedback-components": "static-1.6741",
  "flux-actions": "static-1.350",
  "hubspot-apollo-client": "static-1.5041",
  "integrations-error-boundary-lib": "static-1.14110",
  "integrations-tracking-lib": "static-1.5770",
  "laboratory-lib": "static-3.7313",
  "native-integrations-shared-strings": "static-1.7942",
  "redux-observable": "static-1.11",
  "rxjs": "static-5.10",
  "ui-shepherd-react": "static-3.10421",
  "unified-auth": "static-1.685",
  "breeze-engine-core": "static-1.587",
  "ably": "static-2.2",
  "highlight.js": "static-1.81",
  "navigation-messaging": "static-1.7786",
  "content-media-composition-data-lib": "static-1.12853",
  "content-media-compositions": "static-2.16860",
  "idb-keyval": "static-1.46",
  "media-bridge-lib": "static-1.19217",
  "unified-auth-core-lib": "static-1.967",
  "social-insights-client-types": "static-1.22517",
  "advanced-menus-core": "static-1.15404",
  "advanced-menus-lib": "static-1.12302",
  "ExportDialog": "static-6.10541",
  "ui-memberships-settings-lib": "static-1.34505",
  "conditional-properties-service-client": "static-1.3915",
  "crm-pipelines-api-client-types": "static-1.4255",
  "fdsr-migration-layer": "static-1.177",
  "framework-builder-read-service-client": "static-1.4123",
  "framework-data-schema-quick-fetch": "static-1.6963",
  "inbound-db-meta-service-client": "static-1.3705",
  "multi-currency-client-types": "static-1.3809",
  "persist-promise": "static-1.3863",
  "foundations-components-test-utils": "static-1.5738",
  "reactive-lib": "static-1.888",
  "react-immutable-render-mixin": "static-1.9",
  "hubspot-apollo-cache": "static-1.500",
  "universal-page-editor-lib": "static-1.3174",
  "adobe-sign-auth-lib": "static-1.174",
  "ads-unified-auth-lib": "static-1.653",
  "google-sheets-integration-lib": "static-1.740",
  "microsoft-drive-integration-lib": "static-1.878",
  "surveymonkey-integration-lib": "static-1.192",
  "slack-ui-library": "static-1.10559",
  "js-cookie": "static-1.18",
  "fsm": "static-1.3892",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.15403",
  "simple-menus-lib": "static-1.16920",
  "crm-record-cards-service-types": "static-1.3703",
  "location-customization-utils-lib": "static-1.9753",
  "react-flip-move": "static-1.73"
},
  depPathPrefixes: {
  "feedback-public-submission-ui": "/feedback-public-submission-ui/static-1.30591",
  "emoji-mart": "/emoji-mart/static-3.4",
  "feedback-schema": "/feedback-schema/static-1.55043",
  "head-dlb": "/head-dlb/static-1.5007",
  "hs-test-utils": "/hs-test-utils/static-1.8184",
  "hubspot-dlb": "/hubspot-dlb/static-2.1854",
  "HubStyleTokens": "/HubStyleTokens/static-2.11634",
  "I18n": "/I18n/static-7.1643",
  "quartz": "/quartz/static-1.7241",
  "quartz-config": "/quartz-config/static-1.1019",
  "quartz-core": "/quartz-core/static-1.6460",
  "react-dlb": "/react-dlb/static-1.82",
  "react-dnd": "/react-dnd/static-4.51",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-2.10",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-thunk": "/redux-thunk/static-2.43",
  "reselect": "/reselect/static-3.7",
  "sinon": "/sinon/static-1.9",
  "tinymce": "/tinymce/static-6.5",
  "cssUtils": "/cssUtils/static-1.838",
  "enviro": "/enviro/static-4.455",
  "feedback-shared-ui": "/feedback-shared-ui/static-1.55030",
  "feedback-utils": "/feedback-utils/static-1.55034",
  "forms-embed-utils-lib": "/forms-embed-utils-lib/static-1.4626",
  "forms-utils-lib": "/forms-utils-lib/static-1.12893",
  "foundations-assets": "/foundations-assets/static-1.5036",
  "foundations-components": "/foundations-components/static-1.8255",
  "foundations-theming": "/foundations-theming/static-1.4599",
  "hub-http": "/hub-http/static-1.6383",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4132",
  "HubStyle": "/HubStyle/static-2.11941",
  "icons": "/icons/static-2.660",
  "immutable": "/immutable/static-2.79",
  "quick-fetch": "/quick-fetch/static-1.4034",
  "raven": "/raven/static-3.5925",
  "react": "/react/static-7.188",
  "react-dom": "/react-dom/static-7.85",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "react-redux": "/react-redux/static-7.71",
  "react-rhumb": "/react-rhumb/static-1.16862",
  "react-select-plus": "/react-select-plus/static-1.107",
  "react-utils": "/react-utils/static-2.5458",
  "react-virtualized": "/react-virtualized/static-2.101",
  "redux": "/redux/static-4.16",
  "StyleGuideUI": "/StyleGuideUI/static-3.490",
  "tinymce-plugins": "/tinymce-plugins/static-1.57934",
  "transmute": "/transmute/static-2.85",
  "ui-images": "/ui-images/static-2.1198",
  "UIComponents": "/UIComponents/static-3.8580",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "metrics-js": "/metrics-js/static-1.9637",
  "styled-components": "/styled-components/static-2.89",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3518",
  "moment": "/moment/static-3.26",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3518",
  "quartz-webpack": "/quartz-webpack/static-1.3465",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2315",
  "property-description-translator": "/property-description-translator/static-1.4002",
  "HeadJS": "/HeadJS/static-2.775",
  "framer-motion": "/framer-motion/static-1.74",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3295",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.154",
  "webpack-env": "/webpack-env/static-1.54",
  "i18n-data": "/i18n-data/static-1.224",
  "moment-timezone": "/moment-timezone/static-5.85",
  "jasmine": "/jasmine/static-4.4487",
  "jasmine-runner": "/jasmine-runner/static-1.6619",
  "dispatcher": "/dispatcher/static-1.140",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.850",
  "hubspotter-http": "/hubspotter-http/static-1.4768",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.549",
  "module-federation": "/module-federation/static-1.28",
  "quartz-auth": "/quartz-auth/static-1.916",
  "quartz-head": "/quartz-head/static-1.906",
  "quartz-i18n": "/quartz-i18n/static-1.916",
  "quartz-routing": "/quartz-routing/static-1.671",
  "quartz-test": "/quartz-test/static-1.916",
  "quartz-tracking": "/quartz-tracking/static-1.620",
  "trellis-components": "/trellis-components/static-1.2280",
  "ui-fonts": "/ui-fonts/static-1.896",
  "usage-tracker-container": "/usage-tracker-container/static-1.7504",
  "usage-tracker-core": "/usage-tracker-core/static-1.7364",
  "hs-lodash": "/hs-lodash/static-4.45",
  "sassPrefix": "/sassPrefix/static-1.159",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7410",
  "reference-resolvers": "/reference-resolvers/static-1.8338",
  "sanitize-text": "/sanitize-text/static-1.8309",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "ReduxMessenger": "/ReduxMessenger/static-2.10525",
  "sanitize": "/sanitize/static-1.4639",
  "outpost": "/outpost/static-1.4331",
  "rpc-client-utils": "/rpc-client-utils/static-1.4822",
  "underscore": "/underscore/static-1.8",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4524",
  "floating-ui": "/floating-ui/static-1.59",
  "hs-story-utils": "/hs-story-utils/static-1.9586",
  "react-aria": "/react-aria/static-1.68",
  "react-create-root-preference": "/react-create-root-preference/static-1.41",
  "tanstack-table": "/tanstack-table/static-1.57",
  "trellis-assets": "/trellis-assets/static-1.2261",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3082",
  "foundations-theming-base": "/foundations-theming-base/static-1.3584",
  "stylex": "/stylex/static-1.36",
  "hs-locale-management": "/hs-locale-management/static-1.199",
  "csstype": "/csstype/static-1.50",
  "web-vitals": "/web-vitals/static-1.8",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.9376",
  "atom": "/atom/static-1.5237",
  "codemirror": "/codemirror/static-5.97",
  "content-assistance-lib": "/content-assistance-lib/static-1.8010",
  "ContentUtils": "/ContentUtils/static-1.68859",
  "data-token-picker": "/data-token-picker/static-1.16701",
  "file-manager-components": "/file-manager-components/static-1.24110",
  "FileManagerCore": "/FileManagerCore/static-1.39609",
  "FileManagerLib": "/FileManagerLib/static-1.39750",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.8090",
  "hub-http-contrib": "/hub-http-contrib/static-1.3206",
  "interframe": "/interframe/static-3.4920",
  "layout-dnd-components": "/layout-dnd-components/static-1.12766",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11741",
  "property-translator": "/property-translator/static-1.5558",
  "react-codemirror": "/react-codemirror/static-1.10790",
  "react-colorpicker": "/react-colorpicker/static-2.10371",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8259",
  "rich-text-lib": "/rich-text-lib/static-1.20121",
  "tinymce-data": "/tinymce-data/static-1.40905",
  "tinymce-themes": "/tinymce-themes/static-1.56790",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.10046",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5374",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.15892",
  "bender-build-tools": "/bender-build-tools/static-1.3301",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10376",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10374",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5200",
  "base-ui": "/base-ui/static-1.16",
  "react-day-picker": "/react-day-picker/static-1.5",
  "trellis-theming": "/trellis-theming/static-1.1110",
  "tanstack-virtual": "/tanstack-virtual/static-1.32",
  "autolinker": "/autolinker/static-3.11",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.232",
  "chirp-fetch": "/chirp-fetch/static-1.2051",
  "chatspot-core": "/chatspot-core/static-1.22135",
  "copilot-toolkit": "/copilot-toolkit/static-1.11565",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13192",
  "data-fetching-client": "/data-fetching-client/static-1.9822",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "superstore": "/superstore/static-1.4922",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8867",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.29031",
  "usage-tracker": "/usage-tracker/static-1.7514",
  "cms-field-types": "/cms-field-types/static-1.4976",
  "content-icons-ui": "/content-icons-ui/static-1.2274",
  "integrations-lib": "/integrations-lib/static-1.16695",
  "customer-data-objects": "/customer-data-objects/static-1.7841",
  "apollo-dlb": "/apollo-dlb/static-3.86",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.1309",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4814",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.88",
  "graphql": "/graphql/static-1.84",
  "immer": "/immer/static-1.33",
  "immerable": "/immerable/static-1.4313",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9240",
  "video-components-external": "/video-components-external/static-1.11831",
  "video-data-lib": "/video-data-lib/static-1.35489",
  "audio-components": "/audio-components/static-1.6167",
  "cropperjs": "/cropperjs/static-1.10",
  "feedback-loader": "/feedback-loader/static-1.29606",
  "FileManagerImages": "/FileManagerImages/static-1.37261",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1280",
  "html-to-image": "/html-to-image/static-1.56",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "salesImages": "/salesImages/static-1.528",
  "ui-universal-auth": "/ui-universal-auth/static-1.9171",
  "urlinator": "/urlinator/static-1.4696",
  "video-components": "/video-components/static-1.13833",
  "video-embed": "/video-embed/static-1.36323",
  "ts-schema": "/ts-schema/static-1.4199",
  "ContentData": "/ContentData/static-1.68934",
  "layout-data-lib": "/layout-data-lib/static-1.10066",
  "react-dnd-compat": "/react-dnd-compat/static-1.4776",
  "browser-eslint": "/browser-eslint/static-2.57",
  "batch-promise": "/batch-promise/static-1.1706",
  "external-options-client-types": "/external-options-client-types/static-1.4244",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.7058",
  "hs-promise-utils": "/hs-promise-utils/static-1.5757",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3964",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9171",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3229",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11311",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "markdown-it": "/markdown-it/static-1.6",
  "magpie-lib": "/magpie-lib/static-1.5659",
  "magpie-types": "/magpie-types/static-1.5119",
  "simple-logging-lib": "/simple-logging-lib/static-1.3211",
  "avatar-components": "/avatar-components/static-1.2662",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9985",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6741",
  "flux-actions": "/flux-actions/static-1.350",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.5041",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.14110",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5770",
  "laboratory-lib": "/laboratory-lib/static-3.7313",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7942",
  "redux-observable": "/redux-observable/static-1.11",
  "rxjs": "/rxjs/static-5.10",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10421",
  "unified-auth": "/unified-auth/static-1.685",
  "breeze-engine-core": "/breeze-engine-core/static-1.587",
  "ably": "/ably/static-2.2",
  "highlight.js": "/highlight.js/static-1.81",
  "navigation-messaging": "/navigation-messaging/static-1.7786",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.12853",
  "content-media-compositions": "/content-media-compositions/static-2.16860",
  "idb-keyval": "/idb-keyval/static-1.46",
  "media-bridge-lib": "/media-bridge-lib/static-1.19217",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.967",
  "social-insights-client-types": "/social-insights-client-types/static-1.22517",
  "advanced-menus-core": "/advanced-menus-core/static-1.15404",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12302",
  "ExportDialog": "/ExportDialog/static-6.10541",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.34505",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3915",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4255",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.177",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4123",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6963",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3705",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3809",
  "persist-promise": "/persist-promise/static-1.3863",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5738",
  "reactive-lib": "/reactive-lib/static-1.888",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.500",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3174",
  "adobe-sign-auth-lib": "/adobe-sign-auth-lib/static-1.174",
  "ads-unified-auth-lib": "/ads-unified-auth-lib/static-1.653",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.740",
  "microsoft-drive-integration-lib": "/microsoft-drive-integration-lib/static-1.878",
  "surveymonkey-integration-lib": "/surveymonkey-integration-lib/static-1.192",
  "slack-ui-library": "/slack-ui-library/static-1.10559",
  "js-cookie": "/js-cookie/static-1.18",
  "fsm": "/fsm/static-1.3892",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.15403",
  "simple-menus-lib": "/simple-menus-lib/static-1.16920",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3703",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.9753",
  "react-flip-move": "/react-flip-move/static-1.73"
}
};
